// extracted by mini-css-extract-plugin
export var bottomRightDock = "_51-0";